import React, { Component } from 'react';
import AdministratorsApi from '../../api/administrators';
import Switch from '@mui/material/Switch';
import IndicatorButton from '../../components/IndicatorButton';
import FormControlLabel from '@mui/material/FormControlLabel';
import Validators from '../../utils/Validators';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { showMessage, showError, confirmAction } from '../../actions/uiActions';


import KeyboardBackspace from '@mui/icons-material/KeyboardBackspace';
import { Checkbox, IconButton, ListItemText, MenuItem, Paper, Select } from '@mui/material';
import { Delete } from '@mui/icons-material';
import moment from 'moment/moment';
class Administrator extends Component {
  permissions;
  state = {
    name: '',
    email: '',
    alias_email: '',
    role: '',
    scheduling: '',
    busy: false,
    valid_name: true,
    valid_email: true,
    valid_alias_email: true,
    valid_profile_picture: true,  
    valid_role: true,
    valid_scheduling: true,
    accountManager: false,
    additional_role: '', // Temporary fix to identifying the true role a user is suppose to have.
    domains: [],
    adminDomains: [],
    file: null,
    fileName: "",
    hubspot_id: "",
    valid_hubspot_id: true,  
  };

  handleInputChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };
  handleSelectDomains = (event, child) => {
    const { props: { value } } = child;
    const domainId = value.id;
    const { adminDomains } = this.state;
    if (adminDomains.find(item => item === domainId)) {
      this.setState({ adminDomains: adminDomains.filter(eachDomainId => eachDomainId !== domainId) })
    } else {
      this.setState({ adminDomains: [...adminDomains, domainId] })
    }
  }


  getDomainFilterValue = (selectedDomains) => {
    if (selectedDomains.length === 0) {
      return <span>Assign Domain to admin</span>;
    }
    const selectedDomainDetails = this.state.domains.filter(eachManager => selectedDomains.includes(eachManager.id))
    return selectedDomainDetails.map(each => each.name).join(',');
  }

  handleFileChange = async ({ target }) => { 
    const file = target.files[0];
    const fileName = `file_${moment().format("X")}_${file.name}`
    this.setState({ file, fileName, valid_profile_picture: true});
  }

  componentDidMount() {
    if (this.props.edit) {
      this.setState({
        name: this.props.account.name,
        email: this.props.account.email,
        hubspot_id: this.props.account.hubspot_id,
        role: this.props.account.role,
        scheduling: this.props.account.scheduling,
        accountManager: this.props.account.accountManager,
        additional_role: this.props.account.additional_role,
        adminDomains: this.props.account.domains || [],
        alias_email: this.props.account.alias_email,
        file: this.props.account.profile_picture
      });
    }
    this.setState({
      domains: this.props.domains,
    })
  }
    toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
  });


  save =  () => {
    if (!this.state.name) {
      this.setState({ valid_name: false, invalid: true });
      this.props.showMessage('Please enter the name of the administrator.');
    } else if (!Validators.isValidEmail(this.state.email)) {
      this.setState({ valid_email: false, invalid: true });
      this.props.showMessage('Please enter a valid email address.');
    } else if (!Validators.isValidEmail(this.state.alias_email)) {
      this.setState({ valid_alias_email: false, invalid: true });
      this.props.showMessage('Please enter a valid alias email address.');
    } else if (this.state.accountManager && !this.state.valid_profile_picture) {
      this.setState({ valid_profile_picture: false, invalid: true });
      this.props.showMessage('Please upload a profile picture.');
    } else if (!this.state.role) {
      this.setState({ valid_phone: false, invalid: true });
      this.props.showMessage('Please select a role');
    } else if (
      this.state.role == 'coach' &&
      !Validators.isValidURL(this.state.scheduling)
    ) {
      this.setState({ valid_scheduling: false, invalid: true });
      this.props.showMessage('Please enter a valid URL to schedule calls');
    } else if (this.state.accountManager && !this.state.hubspot_id) {
      this.setState({ valid_hubspot_id: false, invalid: true });
      this.props.showMessage('Please enter valid hubspot ID.');
    } else if (this.props.edit) {
      this.updateAccount()
    } else {
      this.registerAccount();
    }
  };
  updateAccount = async () => {
    try {
      this.setState({ busy: true });
      const account = await AdministratorsApi.update(this.props.account._id, {
        name: this.state.name,
        email: this.state.email,
        alias_email: this.state.alias_email,
        role: this.state.role,
        scheduling: this.state.scheduling,
        accountManager: this.state.accountManager,
        additional_role: this.state.additional_role,
        adminDomains: this.state.adminDomains,
        profile_picture: this.state.fileName ? await this.toBase64(this.state.file) : this.state.file,
        fileName: this.state.fileName ?? "",
        hubspot_id: this.state.hubspot_id ?? ""
      })
      if (!account) {
        this.setState({ busy: false });
        this.props.showMessage(
          'There is already an account registered with the same email address.'
        );
      } else {
        this.props.showMessage('Account updated successfully!');
        this.props.onUpdate({
          id: this.props.account._id,
          name: this.state.name,
          email: this.state.email,
          role: this.state.role,
          additional_role: this.state.additional_role,
          accountManager: this.state.accountManager,
          scheduling: this.state.scheduling,
          domains: this.state.adminDomains
        });
      }

    } catch (error) {
      this.setState({ busy: false });
      this.props.showError(error.message);
    }
  };


  registerAccount = async () => {
    try {
      this.setState({ busy: true });
      const id = await AdministratorsApi.add({
        name: this.state.name,
        email: this.state.email,
        alias_email: this.state.alias_email,
        role: this.state.role,
        scheduling: this.state.scheduling,
        accountManager: this.state.accountManager,
        additional_role: this.state.additional_role,
        adminDomains: this.state.adminDomains,
        profile_picture:this.state.file ? await this.toBase64(this.state.file) : "",
        fileName: this.state.fileName ?? "",
        hubspot_id: this.state.hubspot_id ?? ""
      })
      if (!id) {
        this.props.showMessage(
          'There is already an account registered with the same email address.'
        );
      } else {
        this.props.showMessage(
          'The new account has been registered, an email has been sent to the email address with the login information.'
        );
        this.props.onCreate({
          id,
          name: this.state.name,
          email: this.state.email,
          role: this.state.role,
          additional_role: this.state.additional_role,
          alias_email: this.state.alias_email,
          hubspot_id: this.state.hubspot_id ?? ""
        });
      }
    } catch (error) {
      this.setState({ busy: false });
      this.props.showError();
    }
  };

   renderUploadFile = () => (
    <div className='mt-4'>
      <input
        accept='.png, .jpg, .jpeg'
        type='file'
        id='file-input'
        className='file-input'
        onChange={this.handleFileChange}
      />
      <label htmlFor='file-input' className='file-upload'>
        Upload your profile picture
      </label>
    </div>
  );
  renderPreviewFile = () => (
    <div
      className='file-upload'
      style={{ height:"100px", width:"100%", position:"relative" }}
    >
      <img style={{ height:"100%", width:"100%", objectFit:"cover"}} src={this.state.fileName ? URL.createObjectURL(this.state.file) : this.state.file} alt={"profile picture"} />
      <div style={{position:"absolute", right:"-40px", top:"0"}}>
      <IconButton onClick={() => this.setState({file: null, valid_profile_picture: false})}>
        <Delete />
      </IconButton>
    </div>
    </div>
  );
  render() {
    return (
      <section className="animated fadeIn">
        <header>
          <h1>
            {this.props.edit
              ? 'Manage Administrators > Edit Account'
              : 'Manage Administrators > Register New Account'}
            <button onClick={this.props.onClose} className="close">
              <KeyboardBackspace /> Back
            </button>
          </h1>
        </header>

        <div className="row">
          <div className="col-xl-4 offset-xl-4 col-lg-4 offset-lg-4 col-md-6 offset-md-3 col-12">
            <h4>{this.props.edit ? 'Edit Account' : 'Register New Account'}</h4>
            <div className="line-break"></div>
            <div className="form-group nice">
              <input
                disabled={this.state.busy}
                type="text"
                className="form-control"
                placeholder="Name"
                name="name"
                value={this.state.name}
                onChange={this.handleInputChange}
              />
              {!this.state.valid_name && (
                <div className="input-error animated zoomIn">
                  Enter the name of the administrator
                </div>
              )}
            </div>
            <div className="form-group nice">
              <input
                disabled={this.state.busy}
                type="email"
                className="form-control"
                placeholder="Email Address"
                name="email"
                value={this.state.email}
                onChange={this.handleInputChange}
              />
              {!this.state.valid_email && (
                <div className="input-error animated zoomIn">
                  Enter a valid Email Address
                </div>
              )}
            </div>
            <div className="form-group nice">
              <input
                disabled={this.state.busy}
                type="email"
                className="form-control"
                placeholder="Alias Email Address"
                name="alias_email"
                value={this.state.alias_email}
                onChange={this.handleInputChange}
              />
              {!this.state.valid_alias_email && (
                <div className="input-error animated zoomIn">
                  Enter a valid Alias Email Address
                </div>
              )}
            </div>
            <div className="form-group nice">
              <select
                disabled={this.state.busy}
                className="form-control"
                name="role"
                value={this.state.role}
                onChange={this.handleInputChange}
              >
                <option value="">User role...</option>
                <option value="sales">Sales Representative</option>
                <option value="coach">Student Loans Coach</option>
                <option value="admin">System Administrator</option>
              </select>
              {!this.state.valid_role && (
                <div className="input-error animated zoomIn">
                  Select a user role
                </div>
              )}
            </div>
          
            {!this.props.edit && <div className="form-group nice">
              <Paper style={{ display: 'flex' }} elevation={1}>
                <Select
                  labelId="domains"
                  className='data-filter'
                  value={this.state.adminDomains}
                  renderValue={this.getDomainFilterValue}
                  style={{ width: '100%' }}
                  multiple
                  onChange={this.handleSelectDomains}
                  displayEmpty
                >
                  {this.state.domains.map(({ id, name }) => (
                    <MenuItem key={id} value={{ name, id }}>
                      <Checkbox checked={this.state.adminDomains.includes(id)} />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
            </div>}
            <div className="form-group nice">
              <input
                disabled={this.state.busy}
                type="url"
                className="form-control"
                placeholder="URL to schedule calls (Ex. Calendly)"
                name="scheduling"
                value={this.state.scheduling}
                onChange={this.handleInputChange}
              />
              {!this.state.valid_scheduling && (
                <div className="input-error animated zoomIn">
                  Enter a valid URL
                </div>
              )}
            </div>
            {this.props.auth.account.role === 'admin' && (
              <div className="form-group nice">
                <select
                  disabled={this.state.busy}
                  className="form-control"
                  name="additional_role"
                  value={this.state.additional_role}
                  onChange={this.handleInputChange}
                >
                  <option value="">Additional user role</option>
                  <option value="sales">Sales Representative</option>
                  <option value="coach">Student Loans Coach</option>
                  <option value="admin">System Administrator</option>
                </select>
                {!this.state.valid_role && (
                  <div className="input-error animated zoomIn">
                    Select additional user role
                  </div>
                )}
              </div>
            )}
            <FormControlLabel
              control={
                <Switch
                  checked={this.state.accountManager}
                  onChange={() =>
                    this.setState({
                      accountManager: !this.state.accountManager
                    })
                  }
                  name="accountManager"
                />
              }
              label="Account Manager"
            />
            <div>
              {this.state.accountManager && <>
                {this.state.file ? this.renderPreviewFile() : this.renderUploadFile()}
              </>}
              {!this.state.valid_profile_picture && (
                <div>
                   Please upload a profile picture
                </div>
              )}
            </div>
            {this.state.accountManager && (
              <div className="form-group nice">
                <input
                  type="text"
                  className="form-control"
                  placeholder="HubSpot ID"
                  required
                  disabled={this.state.busy}
                  name="hubspot_id"
                  value={this.state.hubspot_id}
                  onChange={this.handleInputChange}
                />
                {!this.state.valid_hubspot_id && (
                  <div className="input-error animated zoomIn">
                    Enter a valid HubSpot ID
                  </div>
                )}
              </div>
            )}
            <div className="line-break"></div>
            <div className="form-group text-center">
              <button
                className="btn loadin btn-primary"
                onClick={this.save}
                disabled={this.state.busy}
              >
                {this.props.edit ? 'Save Changes' : 'Register Administrator'}
              </button>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
const mapStateToProps = state => {
  return state;
};
export default connect(mapStateToProps, {
  showMessage,
  showError,
  confirmAction
})(Administrator);
